import { Stack } from "@mui/material";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const GlossaryDsfr = (props) => {
  const { page } = props;
  const { title, shortDescription, contents, template } = page;
  const { glossary } = contents;

  const bo = useMemo(() => typeof title === "object", [title]);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack>
          <h1>{title}</h1>
          {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
        </Stack>
      </TemplateBanner>
      <Wrapper>{glossary}</Wrapper>
      <HelpAndShare alwaysDisplayShare template={template} />
    </>
  );
};

GlossaryDsfr.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default GlossaryDsfr;
